import dallmeier from '../../assets/images/services-dallmeier.webp'
import { IAccServices } from '../../models/AccordionServices'

export const accordionDataEn: IAccServices[] = [
    {
        title: 'LEAN',
        content:
            <ul>
                <li>Access control and management systems</li>
                <li>Intercom systems</li>
                <li>Consulting</li>
                <li>Design and solution design</li>
                <li>Installation and commissioning</li>
                <li>After-sales service</li>
                <li>Equipment selection </li>
            </ul>

    },
    {
        title: 'Video surveillance',
        content:
            <ul>
                <li>Analog and IP video surveillance systems</li>
                <li>Video analytics systems </li>
                <li>Consulting</li>
                <li>Design and solution design</li>
                <li>Installation and commissioning</li>
                <li>After-sales service</li>
                <li>Equipment selection</li>
            </ul>
    },
    {
        title: 'Security alarm systems',
        content:
            <ul>
                <li>Consulting</li>
                <li>Design and solution design</li>
                <li>Installation and commissioning</li>
                <li>After-sales service</li>
                <li>Equipment selection</li>
            </ul>
    },
    {
        title: 'Fire safety',
        content:
            <ul>
                <li>Consulting</li>
                <li>Design and solution design</li>
                <li>Installation and commissioning</li>
                <li>After-sales service</li>
                <li>Equipment selection</li>
            </ul>
    },
    {
        title: 'Systems for monitoring the content of harmful substances in the air',
        content:
            <ul>
                <li>Consulting</li>
                <li>Design and solution design</li>
                <li>Installation and commissioning</li>
                <li>After-sales service</li>
                <li>Equipment selection</li>
            </ul>
    },
    {
        title: 'Sound systems',
        content:
            <ul>
                <li>Consulting</li>
                <li>Design and solution design</li>
                <li>Information display system</li>
                <li>Installation and commissioning</li>
                <li>After-sales service</li>
                <li>Equipment selection</li>
            </ul>
    },
    {
        title: 'Situation centers and integrated platforms',
        content:
            <ul>
                <li>Audio conference system</li>
                <li>Videoconferencing system</li>
                <li>Information display system</li>
                <li>Situation Center management system</li>
                <li>Switching system</li>
                <li>Electronic logging system</li>
                <li>Comprehensive information protection system</li>
                <li>Secure video communication</li>
                <li>Confidential video communication</li>
                <li>Open video communication with local governments</li>
                <li>Equipment selection</li>
            </ul>
    },
    {
        title: 'SCS Systems',
        content:
            <div>SCS (Structured cabling system) is the most modern multifunctional network solution that is included in the class of capital structures.<br />The LAN provides a universal telecommunications infrastructure for the building, as well as the transmission of all kinds of signals, including information, video or audio.<br />Our company is engaged in the design, installation (laying) and maintenance of SCS. We have extensive experience in designing and laying:<br />
                <ul>
                    <li>computer networks</li>
                    <li>telephone networks</li>
                    <li>fiber-optic networks (there is experience in building fiber-optic communication lines)</li>
                    <li>welding (as well as design and installation, including in sewers)</li>
                </ul>In addition, we are engaged in the design and installation of Wi-Fi networks, including the introduction of seamless Wi-Fi.<br />We can also take over your LAN network for maintenance, even if you designed and built it without us.
            </div>
    },
    {
        title: 'Power supply',
        content:
            <ul>
                <li>Protection against pulse and switching surges</li>
                <li>Double insulation, workplace isolation</li>
                <li>Potential equalization</li>
                <li>Automatic power off</li>
                <li>Protective grounding</li>
                <li>Equipment selection</li>
            </ul>
    },
    {
        title: 'Triangulation systems for the position of objects, transport, and personnel',
        content:
            <ul>
                <li>Consulting</li>
                <li>Design and solution design</li>
                <li>Information display system</li>
                <li>Installation and commissioning</li>
                <li>After-sales service</li>
                <li>Equipment selection</li>
            </ul>
    },
    {
        title: 'Mobile and portable complexes',
        content:
            <ul>
                <li>Consulting</li>
                <li>Design and solution design</li>
                <li>Information display system</li>
                <li>Installation and commissioning</li>
                <li>After-sales service</li>
                <li>Equipment selection</li>
            </ul>
    },
    {
        title: 'Data transmission systems',
        content:
            <ul>
                <li>Consulting</li>
                <li>Design and solution design</li>
                <li>Information display system</li>
                <li>Installation and commissioning</li>
                <li>After-sales service</li>
                <li>Equipment selection</li>
            </ul>
    },
    {
        title: 'Wi-Fi access points',
        content:
            <ul>
                <li>Consulting</li>
                <li>Design and solution design</li>
                <li>Information display system</li>
                <li>Installation and commissioning</li>
                <li>After-sales service</li>
                <li>Equipment selection</li>
            </ul>
    },
    {
        title: 'IP PBX, IP TV',
        content:
            <ul>
                <li>Professional consulting</li>
                <li>Design and solution design</li>
                <li>Information display system</li>
                <li>Installation and commissioning</li>
                <li>After-sales service</li>
                <li>Equipment selection</li>
            </ul>
    },
    {
        title: 'Panomera Dallmeier - ремонт и обслуживание',
        content:
            <>
                <img src={dallmeier} alt="camera Dallmeier" />
                <div>Company <strong>RS LLC</strong> repairs and maintains Dallmeier video surveillance systems.<br /><br /><strong>List of services provided:</strong><br /><br /><ul><li>preventive and scheduled repairs;</li><li>dismantling, installation and commissioning;</li><li>installation and configuration of the Dallmeier software;</li><li>comprehensive setting up systems based on Dallmeier;</li><li>maintenance and service support.</li></ul>Our specialists have a high level of qualification, they have all the necessary certificates and permits for high-quality work at facilities of any complexity<br />We provide services in the Russian Federation and the CIS countries.<br />A guarantee is provided for all work performed.</div>
            </>

    },
]